import { Api } from 'services/api';
/**
 -@param {string} organizationId
 *@獲取常用資源列表
 */
export const getWebResourceList = async (organizationId) => {
  const response = await Api.get(`/organizations/${organizationId}/webResources`);
  return response;
};